"use strict";
exports.__esModule = true;
exports.ApiConfig = void 0;
var api_1 = require("@libat/api");
exports.ApiConfig = new api_1.Configuration({ basePath: '/api/v1' });
